import useCallApi from '../../utilities/axios'

const baseUrl = `${process.env.REACT_APP_CU_IRB_API_URL}`

export interface RevertOption {
    stepID: number
    stepName: {
        th: string
        en: string
    }
}

export interface RevertStatusRequest {
    stepID: number
}

export interface Timeline {
    timelineName: {
        th: string
        en: string
    }
    date: string
    order: number
}

export interface SubmittedTimeline {
    submittedID: number
    submitTypeInfo: {
        value: number
        nameTH: string
        nameEN: string
    }
    timelineList: Timeline[]
}

const useProject = () => {
    const callApi = useCallApi()

    async function getRevertOptions(projectId: number) {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: RevertOption[]
        }>({
            url: `${baseUrl}/project/${projectId}/status/revert-options`,
        })

        return data
    }

    async function revertStatus(projectId: number, params: RevertStatusRequest) {
        const { data } = await callApi.axiosPut<{
            message: string
            status: number
            result: string
        }>({
            url: `${baseUrl}/project/${projectId}/status/revert`,
            params,
        })

        return data
    }
    async function getTimeline(projectId: number) {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: SubmittedTimeline[]
        }>({
            url: `${baseUrl}/project/${projectId}/timeline`,
        })

        return data
    }

    return {
        getRevertOptions,
        revertStatus,
        getTimeline,
    }
}

export default useProject
